import React, { Component, useEffect, useState } from 'react';
import OrderHistoryView from './OrderHistoryView';
import { callCartItemListeners, getAppCfg, getCurrency } from '../../utils/common';
import crmservices from '../../wsclient/crmservices';
import MyOrderDetailController from './MyOrderDetailController';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { addToCart, clearOrder, getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import MenuItemsController from './MenuItemsController';
import OrderStoresController from './OrderStoresController';
import Addresses from '../addresses/Addresses';
import OrderMerchantsController from './OrderMerchantsController';

function OrderHistoryController(props){
    const [my_orders, setMyOrders] = useState([]);
    const [showLoading, onShowLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [order,setOrder] = useState(null);    
    const [paging, setPaging] = useState({
                page:0
            });
    const [showMenuItems, onShowMenuItems] = useState(false);
    const currency = getCurrency();
    const [message, setMessage] = useState({});
    const [orderToBeReOrder, setOrderToBeReOrder] = useState(null);
    const [showAddresses, onShowAdresses] = useState(false);
    const [showSelectStore, onShowSelectStore] = useState(false);
    const [supp_method, setSuppMethod] = useState(undefined);
    const [showOrderCatalogues, onShowOrderCatalogues] = useState(false);
    const [showStores, onShowStores] = useState(false);
    const [showSelectMerchant, onShowSelectMerchant] = useState(false);
    const [catalogActive, setCatalogActive] = useState([]);

    var app_config = getAppCfg();
    const ordering_model = app_config.features && app_config.features.business_network_details ? app_config.features.business_network_details.ordering_model : null;

    useEffect(()=>{
        loadMyOrders();
    },[])

    const loadMyOrders = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.orders.getMyOrders();
           // console.log('my_orders====', result)
            if (result.code === 'OK') {
                setMyOrders(result.data.content);
                setPaging(result.data.paging);
            }

        } catch (error) {
            console.log("load my order exception:", error);
        }
        onShowLoading(false);
    }
    const onShowDetail = async(item) =>{
        onShowLoading(true);
        try {
            var result = await crmservices.orders.getOrder(item.id);
            console.log('onShowDetail result= ', result)
            if (result.code === 'OK') {
                item = { ...item, ...result.data };
                console.log('onShowDetail item= ', item)
                onShowLoading(false)
                setOrder(item);
                setShowDetail(true);
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log("on get order:", error);
            showMessage(true, t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false)
    }
    const handleLoadMore = async() =>{
        onShowLoadMore(true);
        try {
            var result = await crmservices.orders.getMyOrders({page: 2, size: 20});
            console.log('my_orders====', result.data)
            if (result.code === 'OK') {
                setMyOrders([...my_orders,...result.data.content]);
                setPaging(result.data.paging);
                
                if ( result.data.paging && result.data.paging.size < 20){
                    setHasMore(false);
                }
            }

        } catch (error) {
            console.log("load my order exception:", error);
        }
        onShowLoadMore(false);    }
    // const onReorder1 = async(item) =>{
    //     onShowLoading(true);
    //     try {
    //         var result = await crmservices.orders.getOrder(item.id);
    //         if (result.code === 'OK') {
    //             item = { ...item, ...result.data };
    //             var payload = {
    //                 requested_organisation_id: item.fulfilled_by.id,
    //                 supply_method: item.supply_method
    //             }
    //             if (item.supply_method == 'DELIVERY') {
    //                 payload.lat_lot = item.address.lat + ":" + item.address.lon;
    //             } else if ((item.supply_method == 'PICK_UP' || item.supply_method == 'DIRECT_SALE') && item.fulfilled_by.address) {
    //                 payload.lat_lot = item.fulfilled_by.address.lat + ":" + item.fulfilled_by.address.lon;
    //             }
    //             var orderFulfillmentResult = await crmservices.orders.orderFulfillment(payload);
    //             if (orderFulfillmentResult.code == 'OK' && orderFulfillmentResult.data && orderFulfillmentResult.data.fulfilled_by && orderFulfillmentResult.data.fulfilled_by.length > 0) {
    //                 if (item.supply_method == 'DELIVERY') {
    //                     clearOrder()
    //                     setOrderCache(order_key.order_status, 'NEW', true)
    //                     setOrderCache(order_key.order_type, "DELIVERY", true)
    //                     setOrderCache(order_key.delivery_fulfilled_by, orderFulfillmentResult.data.fulfilled_by[0]);
    //                     setOrderCache(order_key.delivery_address, item.address)    

    //                     await addItemsToCart(item.order_items);
    //                     await getCatalogs('DELIVERY', orderFulfillmentResult.data.fulfilled_by[0].id)
    //                 } else if (item.supply_method == 'PICK_UP' || item.supply_method == 'DIRECT_SALE') {

                        
    //                     clearOrder()
    //                     setOrderCache(order_key.order_status, 'NEW', true)
    //                     setOrderCache(order_key.order_type,item.supply_method == 'PICK_UP' ? "PICK_UP" : "DIRECT_SALE", true)
    //                     setOrderCache(order_key.delivery_fulfilled_by, [])
    //                     setOrderCache(order_key.pick_up_store,orderFulfillmentResult.data.fulfilled_by[0]);
    //                     await addItemsToCart(item.order_items);
    //                     await getCatalogs(item.supply_method == 'PICK_UP' ? 'PICK_UP' : 'DIRECT_SALE', orderFulfillmentResult.data.fulfilled_by[0].id)
    //                 } else {
    //                     showMessage(t('ERROR'),t('EXCEPTION_PROCESS'));
    //                 }
    //             } else if (orderFulfillmentResult.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
    //                 showMessage(t('ERROR'),t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
    //             } else {
    //                 showMessage(t('ERROR'),t('EXCEPTION_PROCESS'));
    //             }
    //         }
    //         else {
    //             showMessage(t('ERROR'),t('EXCEPTION_PROCESS'));
    //         }
    //     } catch (error) {
    //         console.log("reorder exception:", error);
    //         showMessage(t('ERROR'),t('EXCEPTION_PROCESS'));
    //     }
    //     onShowLoading(false);
    // }
    
    const onReorder = async (item) => {
        onShowLoading(true);
        try {
            var result = await crmservices.orders.getOrder(item.id);
            if (result.code === 'OK') {
                item = { ...item, ...result.data };
                setOrderToBeReOrder(item);
                if (item.supply_method == 'DELIVERY') {
                    //await onLoadAddress();
                    //await checkPermission();
                    clearOrder();
                    setOrderCache(order_key.order_status, 'NEW', true)
                    onShowLoading(false);
                    onShowAdresses(true);
                } else if(item.supply_method == 'PICK_UP'){
                    clearOrder();
                    setOrderCache(order_key.order_status, 'NEW', true);
                    setOrderCache(order_key.order_type, 'PICK_UP', true);
                    setOrderCache(order_key.delivery_fulfilled_by, []);
                    // await cache.initOrder({ type: 'PICK_UP', fulfilled_by: [] });
                    await addItemsToCart(item.order_items);
                    onShowSelectStore(true);
                }
            }
        }catch (error) {
            console.log("reorder exception:", error);
            showMessage(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    
    const getCatalogs = async(order_type, fulfilled_by) =>{
        await setOrderCache(order_key.catalog_selected,null)  
        try {
            var body = {
                supply_method: order_type,
                fulfilled_by: fulfilled_by,
                ordering_time: Math.floor(new Date().getTime()/1000),
            }
            var result = await crmservices.orders.getOrderCatalogs(body);
            //console.log('getOrderCatalogs result:', result);
            if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
                //result.data.content[0].life_cycle_state = 'ACTIVE';
                //result.data.content[1].life_cycle_state = 'ACTIVE';
                var catalogActive = result.data.content.filter(catalog => {
                    return catalog.life_cycle_state == "ACTIVE"
                })
                //console.log('catalogActive :', catalogActive);
                if(catalogActive && catalogActive.length > 0 ){ 
                    await setOrderCache(order_key.catalog_selected,catalogActive[0])  
                }
            }
            onShowMenuItems(true)
        } catch (error) {
            console.log("get all categories exception:", error);

        }
    }
    const addItemsToCart = async(order_items) =>{
        for (var index = 0; index < order_items.length; index++) {
            const item = order_items[index];
            if (item.product.name && item.product.name.toLowerCase().includes('delivery')) {
                //do nothing
            } else {
                var productToBeAdded = dataUtil.createItemToReorder(item, true);
                await addToCart(productToBeAdded)
            }
        }
    }
    const clearCart = (order_type) =>{
        var carts = getOrderCache(order_key.cart);
        var isClear = false;
        if (carts && carts.length > 0) {
            if (getOrderCache(order_key.order_status, true) === 'DONE') {
                isClear = true;
            } else {
                //console.log("aaaaaaaaaaaaaaaa", getOrderCache(order_key.order_type, true));
                if (order_type != getOrderCache(order_key.order_type, true)) {
                    isClear = true;
                }
            }
        }
        if (isClear) {
            clearOrder();
        }
        callCartItemListeners();
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
                show: status,
                content: message ? message : null
        })
    }
    const onInitOrderPickUp = async (supply_method, key) => {
        setSuppMethod(supply_method);
        if (key === 'open_menu') {
            clearCart("PICK_UP");
            setOrderCache(order_key.order_status, 'NEW', true)
            var pickupStoreAddress = getOrderCache(order_key.pick_up_store);
            if (pickupStoreAddress && pickupStoreAddress.id) {
                onShowLoading(true);
                try {
                    setOrderCache(order_key.order_type, "PICK_UP", true)
                    setOrderCache(order_key.delivery_fulfilled_by, [])
                    await getCatalogs('PICK_UP', pickupStoreAddress.id)
                    //setState({ showMenuItems: true });
                } catch (error) {
                    console.log('create order exception:', error);
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
                onShowLoading(false);
            } else {
                showMessage(true, t('ORDER_SELECT_STORE'));
            }
        }
        else {
            onShowSelectStore(true)
        }

    }
    const onInitOrderDelivery = async () => {
        onShowLoading(true);
        var deliveryAddress = getOrderCache(order_key.delivery_address)
        if (deliveryAddress) {
            try {
                var isMarketPlace = ordering_model && ordering_model == "MARKETPLACE";
                // console.log("ÂXASDASDASDADAD favourite_shop:",favourite_shop);
                console.log("orderToBeReOrder:", orderToBeReOrder);
                if (!isMarketPlace) {
                    var payload = {
                        supply_method: "DELIVERY",
                    }
                    if (deliveryAddress.id)
                        payload.address_id = deliveryAddress.id// address select
                    else {
                        payload.lat_lot = deliveryAddress.lat + ":" + deliveryAddress.lon //current location
                    }
                    var result = await crmservices.orders.orderFulfillment(payload);
                    //console.log("result:", result);
                    if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                        setOrderCache(order_key.order_type, "DELIVERY", true)
                        setOrderCache(order_key.delivery_fulfilled_by, result.data.fulfilled_by[0]);
                        await getCatalogs("DELIVERY", result.data.fulfilled_by[0].id)
                        //setState({ showMenuItems: true });
                    } else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                        showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                    } else {
                        showMessage(true, t('DELIVERY_VALIDATION_LOCATION'));
                    }
                }
                else {
                    setOrderCache(order_key.order_type, "DELIVERY", true);
                    await addItemsToCart(orderToBeReOrder.order_items);
                    onShowSelectMerchant(true);
                }
            } catch (error) {
                console.log('create order exception:', error)
                showMessage(true, t('EXCEPTION_PROCESS'));
                onShowLoading(false);
            }
            onShowLoading(false);
        } else {
            showMessage(true, t('ORDER_SELECT_ADDRESS'));
        }
    }
    const handleShowRightContent = (target) => {

        callCartItemListeners();

        if (target === 'showMenuItems') {
            onShowMenuItems(!showMenuItems);
            if (catalogActive && catalogActive.length && catalogActive.length > 1) {
                onShowOrderCatalogues(true);
            }
        }
        else if (target === 'showAddresses') {
            onShowAdresses(!showAddresses)
        }
        else if (target === 'showStores') {
            onShowStores(!showStores);
        }
    }
    const onGoBackAfterSetCurrentAddress = async (address) => {
        handleShowRightContent("showAddresses")
        if (address) {
            await setOrderCache(order_key.delivery_address, address);
            onInitOrderDelivery()
        } else {
            showMessage(true, t('ORDER_SELECT_ADDRESS'));
        }
    }
    const onCloseSelectMerchant = async (key) => {
        onShowSelectMerchant(false);
        onShowLoading(true);
        //onInitOrderDelivery(true);
        if (key === 'open_menu') {
            try {
                var delivery_fulfilled_by = await getOrderCache(order_key.delivery_fulfilled_by);
                clearCart('DELIVERY');
                setOrderCache(order_key.order_status, 'NEW', true)
                setOrderCache(order_key.order_type, "DELIVERY", true)
                await getCatalogs('DELIVERY', delivery_fulfilled_by.id);
                //setState({ showMenuItems: true });
            } catch (error) {
                console.log(" select merchant exception:", error);
            }
        }
        onShowLoading(false);
    }

    return (
        <div>
            {props.open&&<OrderHistoryView
                open={props.open}
                onClose={props.onClose}
                my_orders={my_orders}
                showLoading={showLoading}
                currency={currency}
                onShowDetail={onShowDetail}
                handleLoadMore={handleLoadMore}
                hasMore={hasMore}
                showLoadMore = {showLoadMore}
                onReorder={onReorder}
            />}
            {showSelectMerchant && <OrderMerchantsController
                showLoading={showLoading}
                open={showSelectMerchant}
                onClose={onCloseSelectMerchant}
                showMessage={showMessage}
            />}
            {showSelectStore && <OrderStoresController
                showLoading={showLoading}
                open={showSelectStore}
                onClose={() => onShowSelectStore(false)}
                showMessage={showMessage}
                onInitOrderPickUp={onInitOrderPickUp}
                supp_method={supp_method} />}

            {showAddresses && <Addresses
                from='order' 
                reOrder={true}
                open={showAddresses} 
                onCloseItem={() => handleShowRightContent('showAddresses')} 
                onGoBackAfterSetCurrentAddress={onGoBackAfterSetCurrentAddress} 
                onInitReOrderDelivery={onInitOrderDelivery}/>}

            {showDetail && <MyOrderDetailController
                showLoading={showLoading}
                open={showDetail}
                onClose={()=>setShowDetail(false)}
                currency={currency}
                order={order} />}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content} />}

            {showMenuItems && <MenuItemsController
                open={showMenuItems}
                reOrder={true}
                onClose={() => onShowMenuItems(false)}/>} 
        </div>
    );
}

export default OrderHistoryController;